import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesCambioDeDestino() {
  return (
    <ClipperPlaceholder title="Cambio de Destino" category="Novedades" />
  );
}
